import "./careers.scss";

declare var $: any;

$(document).ready(() => {
  setupQuotes();
  setupPositions();
  setupPhotos();
});

let isQuoteActive = false;
let areQuotesPaused = false;
let currentQuoteIdx = 0;
let timeouts: any[] = [];
let isAnimatingOnClick = false;

/* Quotes
-------------------------------------------------------------------------*/

const renderQuote = (quote: any, idx: number) => {
  const person = quote["person"];
  const name = `${person.first_name} ${person.last_name}`;

  return `
    <div class="quote-item" data-idx="${idx}">
      <div class="person">
        <div class="avatar" style="background-image: url('${person.photo}')"></div>
        <div class="texts">
          <h4>${name}</h4>
          <span>${person.title}</span>
        </div>
      </div>
    </div>
  `;
};

const renderQuotes = (quotes: []) => {
  const quotesContainer = document.getElementById("quotes");
  if (!quotesContainer) {
    return;
  }

  const quotesCode = quotes
    .map((quote, idx) => renderQuote(quote, idx)).join("");

  const quotesContainerCode = `
    <div class="quote-container">
      <div id="quote-bubble" class="hidden">
        <div class="rect">
          <p id="quote-text-container"></p>
        </div>
        <div class="chevron">
      </div>
    </div>
    </div>
    <div class="quotes owl-carousel">
      ${quotesCode}
    </div>
  `;

  quotesContainer.innerHTML = quotesContainerCode;
};

const startCarousel = (quotes: []) => {
  const itemDuration = 8000;
  const animationDuration = 750;
  const quotesCount = quotes.length;
  const textContainer = document.getElementById("quote-text-container");
  const owl = $("#quotes .owl-carousel").owlCarousel({
    loop: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: itemDuration,
    smartSpeed: animationDuration,
    mouseDrag: false,
    touchDrag: false,
    center: true,
    items: 7,
    responsiveClass: true,
    responsive: {
      0: {
        items: 2,
      },
      810: {
        items: 3,
      },
      1080: {
        items: 4,
      },
      1350: {
        items: 5,
      },
      1620: {
        items: 6,
      },
      1890: {
        items: 7,
      },
    },
    onChanged: (ev: any) => {
      const idx = ev.relatedTarget.relative(ev.relatedTarget.current());
      if (isNaN(idx) || idx === null || idx >= quotesCount  || idx < 0) {
        return;
      }
      currentQuoteIdx = idx;
      const quoteItem = quotes[idx];
      if (!textContainer || !quoteItem) {
        return;
      }

      textContainer.innerHTML = quoteItem["quote"];

      timeouts.push(setTimeout(() => {
        isQuoteActive = true;
        $("#quote-bubble").removeClass("hidden");
        isAnimatingOnClick = false;
      }, 500));

      timeouts.push(setTimeout(() => {
        isQuoteActive = false;
        $("#quote-bubble").addClass("hidden");
      }, itemDuration - 500));
    },
  });

  const clearTimers = () => {
    for (const timeout of timeouts) {
      clearTimeout(timeout);
    }
    timeouts = [];
  };

  const pauseQuotes = () => {
    if (!isQuoteActive || isAnimatingOnClick) {
      return;
    }

    clearTimers();
    owl.trigger("stop.owl.autoplay");
    areQuotesPaused = true;
  };

  const resumeQuotes = () => {
    if (!areQuotesPaused) {
      return;
    }
    areQuotesPaused = false;
    owl.trigger("play.owl.autoplay");
    timeouts.push(setTimeout(() => {
      isQuoteActive = false;
      $("#quote-bubble").addClass("hidden");
    }, itemDuration - 500));
  };

  // Handle custom hover to pause
  $("#quote-bubble").on({
    mouseenter: (ev: any) => {
      pauseQuotes();
    },
    mouseleave: (ev: any) => {
      resumeQuotes();
    },
  });
  $("#quotes .owl-carousel").on({
    mouseenter: (ev: any) => {
      pauseQuotes();
    },
    mouseleave: (ev: any) => {
      resumeQuotes();
    },
  }, ".owl-item.center");

  // Scroll to clicked item
  $("#quotes .owl-carousel").on("click", ".quote-item", (ev: any) => {
    const target = ev.currentTarget;
    const idx = parseInt(target.getAttribute("data-idx"), 10);
    if (currentQuoteIdx === idx) {
      return;
    }

    clearTimers();
    isAnimatingOnClick = true;

    currentQuoteIdx = idx;
    $("#quote-bubble").addClass("hidden");
    owl.trigger("stop.owl.autoplay");
    owl.trigger("to.owl.carousel", [idx, 500]);
    owl.trigger("play.owl.autoplay");
  });
};

const setupQuotes = () => {
  const loadQuotes = () => {
    const $quotesContainer = $("#quotes");
    $quotesContainer.addClass("loading");

    const url = "/careers/quotes";
    const promise = $.ajax({
      url,
      type: "GET",
      dataType: "json",
      contentType: "application/json",
      data: "{}",
    });

    promise.done((resp: any) => {
      $quotesContainer.removeClass("loading");
      if (resp) {
        renderQuotes(resp);
        startCarousel(resp);
      }
    });
  };

  loadQuotes();
};

/* Positions
-------------------------------------------------------------------------*/

const renderJob = (job: any) => {
  return `
    <a href="${job.link}" class="job-item">
      <div>
        <div class="texts">
          <h3>${job.name}</h3>
          <span>${job.location}</span>
        </div>
        <div class="chevron">
        </div>
      </div>
    </a>
  `;
};

const renderJobs = (jobs: []) => {
  const positionsContainer = document.getElementById("positions");
  if (!positionsContainer) {
    return;
  }

  const jobsCode = jobs
    .map((job) => renderJob(job)).join("");

  const jobsContainerCode = `
    <div class="jobs">
      ${jobsCode}
    </div>
  `;

  positionsContainer.innerHTML = jobsContainerCode;
};

const setupPositions = () => {
  const loadPositions = () => {
    const $positionsContainer = $("#positions");
    $positionsContainer.addClass("loading");

    const url = "https://api.smartrecruiters.com/v1/companies/Thinknum/postings";
    const promise = $.ajax({
      url,
      type: "GET",
      dataType: "json",
      contentType: "application/json",
      data: "{}",
    });

    promise.done((resp: any) => {
      $positionsContainer.removeClass("loading");
      if (resp && resp.content) {
        const content = resp.content;
        const jobs = content.map((item: any) => {
          const id = item.id;
          const name = item.name;
          const locationData = item.location;
          const location = `${locationData.city}, ${locationData.region}`;
          const link = `https://jobs.smartrecruiters.com/Thinknum/${id}`;

          return {
            name,
            location,
            link,
          };
        });
        renderJobs(jobs);
      }
    });
  };

  loadPositions();
};

/* Photos
-------------------------------------------------------------------------*/

const setupPhotos = () => {
  $("#photos .owl-carousel").owlCarousel({
    margin: 5,
    loop: true,
    autoWidth: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 2500,
  });
};
